!((document, Drupal, $) => {
  'use strict';

  /**
   * This function is set up to link disabled.
   */
  Drupal.behaviors.button = {
    attach(context) {
      const $link = $('a[disabled]', context);

      $link.each(function() {
        $(this).on('click', function(e) {
          e.preventDefault();
          console.log('here');
        });
      });
    }
  };
})(document, Drupal, jQuery);
